function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Moving");

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  y: 538.58104,
  width: 836,
  height: 2,
  fill: "var(--tertiaryColor)"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 92,
  y: 378,
  width: 201,
  height: 162,
  fill: "var(--tertiaryColor)"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 165,
  y: 493,
  width: 34,
  height: 46,
  fill: "var(--secondaryColor)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "massage",
  d: "M767,447.419c-6.518,13.80276-61.45512-4.04108-61.45512-4.04108L600.67114,410.41581,574.66752,394.1531l-16.56579-10.36145L592.112,371.3295l1.0121.39008,25.13769,9.66916,97.2879,48.20854S784,411.419,767,447.419Z",
  transform: "translate(-182 -173.41896)",
  fill: "#f7c4a7"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "massage",
  d: "M503.87576,305.45556s-13.1203,5.278-14.64067,20.06615-1.64535,98.22064-1.64535,98.22064,34.28479-19.73709,52.71946-20.141,61.25834-31.50263,61.25834-31.50263S520.88087,299.22448,503.87576,305.45556Z",
  transform: "translate(-182 -173.41896)",
  fill: "#d0cde1"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "massage",
  d: "M503.87576,305.45556s-13.1203,5.278-14.64067,20.06615-1.64535,98.22064-1.64535,98.22064,34.28479-19.73709,52.71946-20.141,61.25834-31.50263,61.25834-31.50263S520.88087,299.22448,503.87576,305.45556Z",
  transform: "translate(-182 -173.41896)",
  opacity: 0.1
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M785.30951,428.39111l-.502-1.03125c-.15283-.31347-15.188-31.74316-6.80518-62.73144,8.3833-30.98926,37.21289-50.55274,37.50293-50.7461l.95264-.63769.50195,1.03125c.15284.31347,15.188,31.74316,6.80469,62.73144-8.38281,30.98926-37.2124,50.55274-37.50244,50.7461ZM815.65131,316.228c-5.04736,3.67187-28.39795,21.8623-35.71826,48.92187-7.32569,27.08106,3.67431,54.54492,6.1831,60.25781,5.04737-3.67187,28.398-21.8623,35.71778-48.92187h0C829.1601,349.40478,818.1601,321.94092,815.65131,316.228Z",
  transform: "translate(-182 -173.41896)",
  fill: "var(--tertiaryColor)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M746.545,376.74664c8.38218,30.98557,37.09305,50.17572,37.09305,50.17572s15.12066-31.0474,6.73848-62.033-37.093-50.17573-37.093-50.17573S738.16278,345.76106,746.545,376.74664Z",
  transform: "translate(-182 -173.41896)",
  fill: "var(--secondaryColor)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M785.76215,427.95752l-1.14453-.0625c-.34863-.01856-35.12256-2.16211-58.12647-24.55469-23.00293-22.39258-26.08056-57.09668-26.10888-57.44531l-.09326-1.1416,1.14453.0625c.34863.01855,35.12256,2.16211,58.126,24.55468,23.00342,22.39356,26.08106,57.09668,26.10938,57.44532Zm-83.2583-81.04883c.75439,6.19531,5.2959,35.44531,25.38281,54.99805,20.08692,19.55468,49.44678,23.30761,55.66065,23.8955-.7544-6.19628-5.2959-35.44433-25.3833-54.998h0C738.06244,351.23486,708.71479,347.49365,702.50385,346.90869Z",
  transform: "translate(-182 -173.41896)",
  fill: "var(--tertiaryColor)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M810.48241,370.0875c-23.00083,22.39038-25.81021,56.8096-25.81021,56.8096s34.48232-1.88275,57.48315-24.27313,25.81021-56.8096,25.81021-56.8096S833.48323,347.69713,810.48241,370.0875Z",
  transform: "translate(-182 -173.41896)",
  fill: "var(--tertiaryColor)"
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  className: "growCircle",
  cx: 602.19281,
  cy: 121.18211,
  r: 15,
  fill: "var(--secondaryColor)"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 550,
  y: 247,
  width: 108,
  height: 52,
  rx: 16.81102,
  fill: "#d0cde1"
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  cx: 350.41519,
  cy: 81.00103,
  r: 49.22371,
  fill: "#4E4637"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M650.71637,685.50978l-3.47308-2.90484.25671,1.814S648.72723,684.80416,650.71637,685.50978Z",
  transform: "translate(-182 -173.41896)",
  fill: "none"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M632.5,578.419l-28,2s-.86011,52.53382-4.5,66l48,38-10-32Z",
  transform: "translate(-182 -173.41896)",
  fill: "#f7c4a7"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M650.71637,685.50978l.00012.00006-.00012-.00006C648.72723,684.80416,649,684.419,649,684.419v-2l-48.92273-39.26257c-.47565,1.7597-.99939,2.91583-1.57727,3.26257-1.79395,1.07636-4.36029,4.59857-6.91382,8.673A38.9884,38.9884,0,0,0,587.5,687.4189v.00006l-2,34h8l2-31h10s17,22,22,30,27,10,49-5C695.08966,702.74422,661.55914,689.35616,650.71637,685.50978Z",
  transform: "translate(-182 -173.41896)",
  fill: "#4E4637"
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  cx: 350.5,
  cy: 104.5,
  r: 32,
  fill: "#f7c4a7"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M550,295.419l-17,57-41-30s21-23,21-29S550,295.419,550,295.419Z",
  transform: "translate(-182 -173.41896)",
  fill: "#f7c4a7"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M386.5,459.919s-49,59-2,95c20.68113,15.84087,38.84518,45.81608,52.703,74.4196a171.00537,171.00537,0,0,0,112.29691,91.58038l.00008,0s167-195,110-250-211-7-211-7Z",
  transform: "translate(-182 -173.41896)",
  fill: "#4E4637"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M525.23,410.169c.22,13.17-2.3,27.63-13.73,30.75-22,6-24,3-24,3s-4,7-3,15-9.5,1.5-9.5,1.5-106.5,13.5-102.5-1.5,42-67,42-67,62-87,75-84c.44.1.89.22,1.36.35,13.24,3.86,35.71,20.89,37.64,27.65,2,7-6,51-6,51A126.264,126.264,0,0,1,525.23,410.169Z",
  transform: "translate(-182 -173.41896)",
  fill: "#d0cde1"
});

var _ref23 = /*#__PURE__*/React.createElement("circle", {
  cx: 356.9898,
  cy: 16.35063,
  r: 16.35063,
  fill: "#4E4637"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M557.38886,199.89572a16.35188,16.35188,0,0,0-1.39736-21.88563q.68538.441,1.33864.95737A16.35064,16.35064,0,1,1,536.99,204.57312q-.65183-.51779-1.23538-1.08734A16.35182,16.35182,0,0,0,557.38886,199.89572Z",
  transform: "translate(-182 -173.41896)",
  fill: "#4E4637"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M541.41165,231.53114c18.60919,5.05625,31.30389,17.95517,28.35441,28.81052-1.31972,4.85715-5.55821,8.47235-11.49544,10.54175l-5.20961-6.4625-.23663,7.84244c-.82409.14033-1.66065.26557-2.5226.35718l-6.6186-13.93841-3.77368,13.8888a58.61642,58.61642,0,0,1-9.17886-1.72905c-18.60918-5.05625-31.30388-17.95517-28.3544-28.81052S522.80247,226.47489,541.41165,231.53114Z",
  transform: "translate(-182 -173.41896)",
  fill: "#4E4637"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "massage",
  d: "M682.5,532.919c-13,8-21-49-21-49l-94-57-21.38-21.99-13.62-14.01,36-4,.89.62,22.11,15.38,83,70S695.5,524.919,682.5,532.919Z",
  transform: "translate(-182 -173.41896)",
  fill: "#f7c4a7"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M522.5,386.919a126.264,126.264,0,0,1,2.73,23.25c-6.99,1.27-13.3,1.73-17.73.75-18-4-56,7-56,7s20-81,25-95a24.47467,24.47467,0,0,1,14.36-14.65c13.24,3.86,35.71,20.89,37.64,27.65C530.5,342.919,522.5,386.919,522.5,386.919Z",
  transform: "translate(-182 -173.41896)",
  opacity: 0.1
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M574.5,394.919s-13.18,5.38-28.38,10.01l-13.62-14.01,36-4,.89.62C572.61,392.12892,574.5,394.919,574.5,394.919Z",
  transform: "translate(-182 -173.41896)",
  opacity: 0.1
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  className: "massage",
  d: "M498.5,301.919s-14,2-19,16-25,95-25,95,38-11,56-7,67-16,67-16S516.5,299.919,498.5,301.919Z",
  transform: "translate(-182 -173.41896)",
  fill: "#d0cde1"
});

var _ref30 = /*#__PURE__*/React.createElement("polygon", {
  points: "693.837 381.807 699.187 367.541 749.118 339.009 783 331.876 693.837 381.807",
  fill: "var(--tertiaryColor)"
});

var _ref31 = /*#__PURE__*/React.createElement("polygon", {
  points: "510.163 381.807 504.813 367.541 454.882 339.009 421 331.876 510.163 381.807",
  fill: "var(--tertiaryColor)"
});

var _ref32 = /*#__PURE__*/React.createElement("polygon", {
  points: "697.404 385.373 506.596 385.373 490.547 310.477 713.453 310.477 697.404 385.373",
  fill: "var(--tertiaryColor)"
});

var _ref33 = /*#__PURE__*/React.createElement("polygon", {
  points: "697.404 385.373 506.596 385.373 490.547 310.477 713.453 310.477 697.404 385.373",
  opacity: 0.1
});

var _ref34 = /*#__PURE__*/React.createElement("rect", {
  x: 505.70443,
  y: 380.91502,
  width: 192.59113,
  height: 158.10837,
  fill: "var(--tertiaryColor)"
});

var _ref35 = /*#__PURE__*/React.createElement("rect", {
  x: 585,
  y: 492,
  width: 34,
  height: 46,
  fill: "var(--secondaryColor)"
});

var SvgMassage = function SvgMassage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "efff930b-7031-4101-bb54-2d24ab2f7925",
    "data-name": "Layer 1",
    width: 836,
    height: 553.16208,
    viewBox: "0 0 836 553.16208",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMassage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/massage.ca9a9297.svg";
export { ForwardRef as ReactComponent };